<template>
  <div>
    <TeamSelector @shareTeamSelection="onShareTeamSelection" />
  </div>
</template>

<script>
import TeamSelector from '../components/team-selector/TeamSelector'

export default {
  page: 'teamSelector',
  components: { TeamSelector },
  props: [ 'item' ],
  created () {
    console.info('teamSelectorMetadata:', this.item.teamSelectorMetadata)
  },
  methods: {
    onShareTeamSelection (teamSelection) {
      try {
        const shareOptions = {
          title: 'My dream team',
          text: `Formation: ${teamSelection.formation}, Players: ${teamSelection.players.join(', ')}, #AFTV11`,
          url: teamSelection.url
        }
        this.$store.commit('share', shareOptions)
      } catch (err) {
        console.info(err.name, err.message)
      }
    }
  }
}
</script>
